import { instance } from "./";

export const getRequestList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/request-organization"
  });
  return response;
};

export const getRequestCard = id => {
  const response = instance({
    method: "get",
    url: `/work/api/request-organization/${id}/card`
  });
  return response;
};

export const getRequestFullInfo = id => {
  const response = instance({
    method: "get",
    url: `/work/api/request-organization/${id}`
  });
  return response;
};

export const getRequestSpecialities = id => {
  const response = instance({
    method: "get",
    url: `/work/api/request-organization/${id}/speciality`
  });
  return response;
};

export const getRequestWorldSkills = id => {
  const response = instance({
    method: "get",
    url: `/work/api/request-organization/${id}/world-skill`
  });
  return response;
};

export const getRequestRoles = id => {
  const response = instance({
    method: "get",
    url: `/work/api/request-organization/${id}/role`
  });
  return response;
};

export const updateRequest = (id, main) => {
  const data = {
    main: {
      ...main,
    },
    specialities: main.specialities,
    worldSkills: main.worldSkills,
  }

  const response = instance({
    method: "put",
    url: `/work/api/request-organization/${id}`,
    data
  });
  return response;
};

export const deleteRequest = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/request-organization/${id}`
  });
  return response;
};

export const acceptRequest = data => {
  const response = instance({
    method: "post",
    url: `/work/api/request-organization/rpc`,
    data
  });
  return response;
};

export const declineRequest = data => {
  const response = instance({
    method: "post",
    url: `/work/api/request-organization/rpc`,
    data
  });
  return response;
};

export const restoreRequest = data => {
  const response = instance({
    method: "post",
    url: `/work/api/request-organization/rpc`,
    data
  });
  return response;
};

export const getRegionList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/dict/region"
  });
  return response;
};

export const getMunicipalsList = (region) => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/municipal?regionId=${region}`
  });
  return response;
};

export const getSpecialitiesList = () => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/speciality`
  });
  return response;
};

export const getWorldSkillsList = () => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/world-skill`
  });
  return response;
};

export const getRolesList = () => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/role`
  });
  return response;
};

export default {
  getRequestList,
  getRequestCard,
  getRequestFullInfo,
  getRequestSpecialities,
  getRequestWorldSkills,
  getRequestRoles,
  updateRequest,
  deleteRequest,
  acceptRequest,
  declineRequest,
  restoreRequest,
  getRegionList,
  getMunicipalsList,
  getSpecialitiesList,
  getWorldSkillsList,
  getRolesList
};
